import { AnalyticsEvent } from '@enums';
import { xhr } from '@services/http';
import { Analytics } from './interfaces';

export const trackEvent = <T extends AnalyticsEvent>(data: Analytics.TrackEvent.Request<T>) => {
  return xhr.post(`/analytics/track-event`, data);
};